// Ликвидатор (deus_likvidator, rare) — trigger: каждый раз, когда Герой владельца атакует,
// этот юнит +1/0/0 (постоянный бафф). Несколько Ликвидаторов на поле — каждый получает.

export const CARD_ID = 'deus_likvidator';

export function likvidatorOnHeroAttack(state, ownerIdx) {
  const p = state.players[ownerIdx];
  if (!p) return;
  for (const u of p.unitsOnField()) {
    if (u.id !== CARD_ID) continue;
    u.current.atk += 1;
    state.log.add(`💪 Ликвидатор [${p.name}]: Герой атаковал → +1 атаки (atk=${u.current.atk})`);
  }
}
